import menu from "magicbean-saas-common/src/core/language/en/menu.json";
import common from "./common.json";
import merchants from "./merchants.json";

export default {
  menu,
  common,
  merchants,
};
